<template>
  <ion-page class="NativeTabNavigatoLayout">
    <!-- <ion-header mode="ios">
      <ion-toolbar>
        <ion-title class="f-center">xxxx</ion-title>
      </ion-toolbar>
    </ion-header>-->
    <ion-content>
      <ion-router-outlet class="sssssssaa" />
    </ion-content>
    <ion-tabs
      class="native-tab-navigato NativeTabNavigatoLayout"
      @ionTabsWillChange="ionTabsWillChange"
      @ionTabsDidChange="ionTabsDidChange"
    >
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="news" @click="tabChange('news')" href="/nativeTab/news">
          <img v-if="tabActiveKey != 'news'" class="newsImage" src="@/assets/tab-nav/news.png" />
          <img v-else class="newsImage" src="@/assets/tab-nav/news-active.png" />

          <ion-label>消息</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="case" @click="tabChange('case')" href="/nativeTab/case">
          <img v-if="tabActiveKey != 'case'" class="newsImage" src="@/assets/tab-nav/case.png" />
          <img v-else class="caseImage" src="@/assets/tab-nav/case-active.png" />
          <ion-label>案件</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="lawyer" @click="tabChange('lawyer')" href="/nativeTab/lawyer">
          <img v-if="tabActiveKey != 'lawyer'" class="newsImage" src="@/assets/tab-nav/lawyer.png" />
          <img v-else class="lawyerImage" src="@/assets/tab-nav/lawyer-active.png" />
          <ion-label>律师</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="my" @click="tabChange('my')" href="/nativeTab/my">
          <img v-if="tabActiveKey != 'my'" class="newsImage" src="@/assets/tab-nav/my.png" />
          <img v-else class="myImage" src="@/assets/tab-nav/my-active.png" />
          <ion-label>我的</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { ref } from 'vue'
import { useRoute } from 'vue-router'

export default {
  setup() {
    const route = useRoute()

    const pathMap = {
      '/nativeTab/news': 'news',
      '/nativeTab/case': 'case',
      '/nativeTab/lawyer': 'lawyer',
      '/nativeTab/my': 'my',
    }
    const tabActiveKey = ref(pathMap[route.path])
    const tabChange = (key) => {
      console.log(key)
      // tabActiveKey.value = key
    }
    const ionTabsDidChange = (e) => {
      console.log('ionTabsDidChange')
    }
    const ionTabsWillChange = (e) => {
      console.log('ionTabsWillChange')
    }
    return {
      tabActiveKey,
      tabChange,
      ionTabsWillChange,
      ionTabsDidChange,
    }
  },
}
</script>
<style lang="scss">
.NativeTabNavigatoLayout {
  .newsImage {
    width: 42px;
    height: 42px;
  }
  .caseImage {
    width: 38px;
    height: 42px;
  }
  .lawyerImage {
    width: 34px;
    height: 38px;
  }
  .myImage {
    width: 40px;
    height: 39px;
  }
}
</style>